async function GetQuestions(designid, componentid) {

    if (
        designid.length > 0 &&
        componentid.length > 0
    ) {

        let response;

        let params = JSON.stringify({
            "DesignID": designid,
            "ComponentID": componentid
        });

        response = await fetch("https://api.cssi.co/CNF/GetQuestions", {
            method: "POST",
            body: params
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })

        return Promise.resolve(response);

    }
}

export default GetQuestions;